// extracted by mini-css-extract-plugin
export default {"container":"addTest_container__3afa8","enableBarDiv":"addTest_enableBarDiv__cajfs","toggleSwitch":"addTest_toggleSwitch__AmGro","slider":"addTest_slider__673aA"};